import { USER_ACTIONS } from './actionTypes';

export const userInitState = {
	userId: null,
	userName: null,
	roleId: null,
	email: null,
	fName: null,
	mName: null,
	lName: null,
	mainPhonecodeCountry: null,
	mainPhoneNumber: null,
	birthDate: null,
	token: '',
	courses: null,
	isLogged: false,
	unreadMessagesCount: 0,
};

const userReducer = (state, action) => {
	switch (action.type) {
		case USER_ACTIONS.LOG_IN:
			return { ...action.payload, isLogged: true };
		case USER_ACTIONS.LOG_OUT:
			return userInitState;
		case USER_ACTIONS.RESET_UNREAD_MESSAGES:
			return { ...state, unreadMessagesCount: 0 };
		case USER_ACTIONS.UPDATE_USER_DETAILS:
		case USER_ACTIONS.UPDATE_PREFERRED_LANGUAGE_ID:
			return { ...state, ...action.payload };

		default:
			return state;
	}
};

export default userReducer;
